import { ScheduledSectionStatusServant } from '../../servants/scheduled_section_status_servant';
import { ISection } from '../../../../interfaces/scheduler_interfaces';
import { ScheduledSectionServant } from '../../servants/scheduled_section_servant';

import * as _4 from 'lodash4';
import { ProcessSelectedRegisterableSectionCommand } from '../../../../components/section_selections/commands/process_selected_registerable_section_command';
import { SectionSwapServant } from '../../../../swap/servants/section_swap_servant';
import { SelectedSectionActionsFacade } from '../../facades/selected_section_actions_facade';
import { SectionSelectionsQuery } from '../../../../components/section_selections/queries/section_selections_query';
import { UpdateSectionSelectionCommand } from '../../../../components/section_selections/commands/update_section_selection_command';
import { RegisteredSectionServant } from '../../servants/registered_section_servant';
import { SectionSelectionsServant } from '../../../../components/section_selections/servants/section_selections_servant';

class SectionTileCheckbox {
  private section: ISection;
  private canBeRegistered: boolean;
  private isRegisteredOrCompleteOrInProgress: boolean;
  private showCheckbox = false;
  private showLock = false;
  private isInSwapMode = false;
  constructor(
    private ngScheduledSectionStatusServant: ScheduledSectionStatusServant,
    private ngScheduledSectionServant: ScheduledSectionServant,
    private processSelectedRegisterableSectionCommand: ProcessSelectedRegisterableSectionCommand,
    private updateSectionSelectionsCommand: UpdateSectionSelectionCommand,
    private ngSectionSwapServant: SectionSwapServant,
    private ngSectionSelectionsQuery: SectionSelectionsQuery,
    private ngSectionSelectionsServant: SectionSelectionsServant
  ) {}
  initialize() {
    this.isInSwapMode = this.ngSectionSwapServant.isInSwapMode();
    this.canBeRegistered = this.ngScheduledSectionServant.canBeRegistered(this.section);
    this.isRegisteredOrCompleteOrInProgress =
      this.ngScheduledSectionStatusServant.isStatusRegisteredOrCompleteOrInProgress(this.section);
    if (this.isRegisteredOrCompleteOrInProgress) {
      this.canBeRegistered = false;
    }
    this.showCheckbox = this.shouldShowCheckbox();
    this.showLock = this.shouldShowLock();
  }

  $onInit() {
    this.initialize();
  }

  $onChanges() {
    this.initialize();
  }

  canAddFromWaitlist() {
    return this.ngScheduledSectionServant.canAddFromWaitlist(this.section);
  }

  getListTypeLabel() {
    if (this.canAddFromWaitlist()) {
      return 'register and drop lists';
    }
    if (this.canBeRegistered) {
      return 'register list';
    }
    return this.section.can_withdraw ? 'withdraw list' : 'drop list';
  }

  sectionCheckboxToggleEnded(event: any) {
    const sectionId = this.section.id;
    if (!event.target) {
      return;
    }
    const isChecked = event.target.checked;
    this.updateSectionSelectionsCommand(sectionId, isChecked).then(() =>
      this.processSelectedRegisterableSectionCommand(sectionId, isChecked)
    );
  }

  shouldShowCheckbox() {
    const isWithdrawnSection = this.ngScheduledSectionStatusServant.isStatusWithdrawn(this.section);
    const canBeSelectedForRegister = this.ngSectionSelectionsServant.canBeSelectedForRegister(this.section);
    const canBeSelectedForWaitlist = this.ngSectionSelectionsServant.canBeSelectedForWaitlist(this.section);
    const canBeSelectedForDrop = this.ngSectionSelectionsServant.canBeSelectedForDrop(this.section);
    const canBeSelectedForWithdraw = this.ngSectionSelectionsServant.canBeSelectedForWithdraw(this.section);

    // No checkbox
    if (this.isInSwapMode || isWithdrawnSection) {
      return false;
    }
    // Show checkbox
    else if (canBeSelectedForRegister || canBeSelectedForWaitlist || canBeSelectedForDrop || canBeSelectedForWithdraw) {
      return true;
    }
    // Fallback
    return false;
  }

  shouldShowLock() {
    const isSectionScheduled = this.ngScheduledSectionServant.isSectionScheduled_(this.section);
    const canBeRegistered = isSectionScheduled && this.ngScheduledSectionServant.canBeRegistered(this.section);
    const canBeSelectedForWaitlist = this.ngSectionSelectionsServant.canBeSelectedForWaitlist(this.section);
    if (canBeRegistered && !this.section._isEligibleForRegistration && !canBeSelectedForWaitlist) {
      return true;
    }
    return false;
  }
}

class SectionTileCheckboxComponent implements ng.IComponentOptions {
  public bindings: ng.IComponentOptions['bindings'];
  public controller: ng.IComponentOptions['controller'];
  public templateUrl: ng.IComponentOptions['templateUrl'];
  constructor() {
    this.bindings = {
      section: '<'
    };
    this.controller = SectionTileCheckbox;
    this.templateUrl =
      'capability-ng-scheduler/src/views/course_scheduler/components/section_tile_checkbox/section_tile_checkbox.html';
  }
}
angular.module('capability-ng-scheduler').component('sectionTileCheckbox', new SectionTileCheckboxComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/components/section_tile_checkbox/section_tile_checkbox.ts